import { Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { ImageComponent } from '@valk-nx/components/ui-image/src/lib/image.component';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';

export interface OverlayCount {
	total: number;
	hidden: number;
}

@Component({
	selector: 'vp-image-grid-cell',
	templateUrl: './image-grid-cell.html',
	imports: [ImageComponent, TranslatePipe],
	host: { class: 'relative block' },
})
export class ImageGridCellComponent {
	readonly image = input.required<PhotoInterface>();
	readonly width = input.required<number>();
	readonly height = input.required<number>();
	readonly overlayCount = input<OverlayCount>();
}
